import React from "react";

import swal from 'sweetalert';

import Server from "../../../services/Server";

function SubscribersLoader(props) {
    const theForm = React.useRef(null);
    const [isLoading, setLoadingStatus] = React.useState(true);

    const
        { currentUser = {} } = props,
        { uid, customLogo = false } = currentUser;

    React.useEffect(() => {
        Server.getMysqlConnectionData(props.event.id)
            .then((res) => {
                theForm.current.host.value = res.data.host;
                theForm.current.user.value = res.data.user;
                theForm.current.password.value = res.data.password;
                theForm.current.port.value = res.data.port;
                theForm.current.database.value = res.data.database;
                setLoadingStatus(false);
            })
            .catch((err) => {
                setLoadingStatus(false);
            });
    }, [props.event.id]);


    const testConnection = (e) => {
        e.preventDefault();
        const { host, user, password, port, database } = theForm.current.elements;
        setLoadingStatus(true);
        _testConnection({
            host: host.value,
            user: user.value,
            password: password.value,
            port: port.value,
            database: database.value
        })
            .then((res) => {
                if (res === "ok") {
                    swal({
                        title: "",
                        text: "La conexión ha sido exitosa",
                        icon: "success",
                        buttons: false,
                        dangerMode: false
                    })
                        .then(() => {
                            setLoadingStatus(false);
                        });
                } else {
                    swal({
                        title: "La conexión NO ha sido exitosa",
                        text: res.data.code,
                        icon: "error",
                        buttons: false,
                        dangerMode: true
                    })
                        .then(() => {
                            setLoadingStatus(false);
                        });
                }
            })
            .catch((err) => {
                swal({
                    title: "",
                    text: "La conexión NO ha sido exitosa",
                    icon: "error",
                    buttons: false,
                    dangerMode: true
                })
                    .then(() => {
                        setLoadingStatus(false);
                    });
            });


    }

    const _testConnection = ({ host, user, password, port, database }) => {
        return new Promise((resolve, reject) => {
            Server.testMysqlConnection({
                host: host,
                user: user,
                password: password,
                port: port,
                database: database
            })
                .then((res) => {
                    resolve(res.data.status);
                })
                .catch(reject);
        });
    }

    const saveConnection = (e) => {
        e.preventDefault();
        const { host, user, password, port, database } = theForm.current.elements;
        setLoadingStatus(true);

        _testConnection({
            host: host.value,
            user: user.value,
            password: password.value,
            port: port.value,
            database: database.value
        })
            .then((res) => {
                if (res === "ok") {
                    Server.saveMysqlConnection(props.event.id, {
                        host: host.value,
                        user: user.value,
                        password: password.value,
                        port: port.value,
                        database: database.value,
                        uid: uid,
                        hasCustomBrand: customLogo
                    })
                        .then((res) => {
                            swal({
                                title: "",
                                text: "La conexión ha sido exitosa",
                                icon: "success",
                                buttons: false,
                                dangerMode: false
                            })
                                .then(() => {
                                    setLoadingStatus(false);
                                });
                        })
                        .catch((err) => {
                            swal({
                                title: "",
                                text: "La conexión NO ha sido exitosa",
                                icon: "error",
                                buttons: false,
                                dangerMode: true
                            })
                                .then(() => {
                                    setLoadingStatus(false);
                                });
                        });
                } else {
                    swal({
                        title: "",
                        text: "La conexión NO ha sido exitosa",
                        icon: "error",
                        buttons: false,
                        dangerMode: true
                    })
                        .then(() => {
                            setLoadingStatus(false);
                        });
                }
            })
            .catch(() => {
                swal({
                    title: "",
                    text: "La conexión NO ha sido exitosa",
                    icon: "error",
                    buttons: false,
                    dangerMode: true
                })
                    .then(() => {
                        setLoadingStatus(false);
                    });
            });

    }

    return (
        <div className="row row-sm subscribers-bd">
            <button
                className="btn btn-az-primary"
                style={{ position: "absolute", left: "4px" }}
                onClick={(e) => { props.handleLoader() }}>
                <i className="fas fa-arrow-left"></i> Volver</button>
            <h3>Cargar desde Base de Datos MySQL</h3>
            <form ref={theForm}>
                <div className="row row-xs align-items-center mg-b-20">
                    <div className="col-md-4">
                        <label className="form-label mg-b-0">Dirección del Servidor</label>
                    </div>
                    <div className="col-md-8 mg-t-5 mg-md-t-0">
                        <input name="host" className="form-control" />
                    </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                    <div className="col-md-4">
                        <label className="form-label mg-b-0">Usuario</label>
                    </div>
                    <div className="col-md-8 mg-t-5 mg-md-t-0">
                        <input name="user" className="form-control" />
                    </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                    <div className="col-md-4">
                        <label className="form-label mg-b-0">Contraseña</label>
                    </div>
                    <div className="col-md-8 mg-t-5 mg-md-t-0">
                        <input name="password" type="password" className="form-control" />
                    </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                    <div className="col-md-4">
                        <label className="form-label mg-b-0">Puerto</label>
                    </div>
                    <div className="col-md-8 mg-t-5 mg-md-t-0">
                        <input name="port" type="number" defaultValue="3306" readOnly={true} className="form-control" />
                    </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                    <div className="col-md-4">
                        <label className="form-label mg-b-0">Nombre de la Base de Datos</label>
                    </div>
                    <div className="col-md-8 mg-t-5 mg-md-t-0">
                        <input name="database" type="text" className="form-control" />
                    </div>
                </div>


                <button
                    className="btn btn-az-primary"
                    disabled={isLoading}
                    onClick={saveConnection}>
                    <i className={"fas fa-" + (isLoading ? 'spinner fa-spin' : 'save')}></i> Guardar</button>

                <button
                    className="btn btn-success"
                    type="button"
                    disabled={isLoading}
                    onClick={testConnection}>
                    <i className={"fas fa-" + (isLoading ? 'spinner fa-spin' : 'drum')}></i> Probar</button>
            </form>
        </div>
    )
}

export default SubscribersLoader;